import React from 'react';
import { connect } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';

import ItemCard from 'tradera-components/item-card/item-card';

const RecentlyViewed = props => {
    const { items } = props;
    const { t } = useTranslator();
    // Memoized link component to avoid rerendering of item cards

    if (!items || (items && items.length === 0)) return null;

    const activeItems = items.filter(
        item =>
            !('recentItemEndDate' in item) ||
            Date.parse(item.recentItemEndDate) > Date.now()
    );

    if (activeItems.length === 0) return null;

    return (
        <section className="pt-5">
            <h3 className="start-page-section-title">
                {t('recentlyViewed_header')}
            </h3>
            <div className="item-card-layout layout-grid ml-lg-1 ml-xl-0 mr-lg-n1 mr-xl-n2">
                {activeItems.map(item => (
                    <div key={item.itemId} className="item-card-container pb-2">
                        <ItemCard
                            item={item}
                            ready={!!item.itemUrl}
                            gaCategory="Startpage recently viewed"
                        />
                    </div>
                ))}
            </div>
        </section>
    );
};

const mapStateToProps = state => ({
    items: state.items.recent
});

const ConnectedRecentlyViewed = connect(mapStateToProps)(RecentlyViewed);

export { ConnectedRecentlyViewed as RecentlyViewed };
